import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CriteriaInputNumberComponent from '../../components/criteria/CriteriaInputNumberComponent';
import SettingService from '../../services/SettingService';
import WelcomeSurveyService from '../../services/WelcomeSurveyService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class WelcomeSurveyListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new WelcomeSurveyService());
        this.settingService = new SettingService();
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statusOptions: [],
        };
        this.statusLabel = this.statusLabel.bind(this);
    }

    //override
    afterRowSelected(e) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${e?.value[0].id}/`+sessionStorage.getItem('i18nextLng');
        this.handleGoToDetail(detailHref, e.originalEvent);
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            status: criteria.status,
            surveyVersion: criteria.surveyVersion,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            status: undefined,
            surveyVersion: undefined,
            locale: this.authService.getI18n(),
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('QuizStatus')
            .then((statusOptions) => {
                this.setState({
                    statusOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('welcome-survey.getStatusOptions.error'));
            });
    }

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'welcome-survey.listTitle';
    }
    getCriteriaName() {
        return 'welcome-survey-list-sc';
    }

    getContainerListName() {
        return 'welcome-survey-list-container';
    }

    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaDropdownComponent
                        id='statusSc'
                        name='status'
                        showClear
                        label={t('welcome-survey.status')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.status}
                        options={this.state.statusOptions}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        filter
                    />
                    <CriteriaInputNumberComponent
                        id='surveyVerionSc'
                        name='surveyVersion'
                        label={t('welcome-survey.surveyVersion')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.surveyVersion}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        validators=''
                    />
                </div>
            </div>
        );
    }
    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('global.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    activeTemplate(field, rowData) {
        if (rowData[field]) {
            return t('welcome-survey.activeYes');
        } else {
            return t('welcome-survey.activeNo');
        }
    }

    prepareColumns() {
        return [
            {
                field: 'active',
                header: t('welcome-survey.list.active'),
                sortable: true,
                body: this.activeTemplate.bind(this, 'active'),
            },
            {
                field: 'surveyVersion',
                header: t('welcome-survey.list.version'),
                sortable: true,
            },
            {
                field: 'status.label',
                header: t('welcome-survey.list.status'),
                sortField: 'status',
                body: this.statusLabel.bind(this),
                sortable: true,
            },
            {
                key: 'actions',
                header: t('global.details'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    statusLabel(e) {
        return e.status.label;
    }
    //override
    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/`+sessionStorage.getItem('i18nextLng');
        return (
            <div>
                <ActionLink
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
            </div>
        );
    }

    breadCrumbItems() {
        return [{name: t('welcome-survey.listTitle'), url: '/welcome-survey-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

WelcomeSurveyListContainer.defaultProps = {
    detailUrl: '/welcome-survey/details',
    newUrl: '/welcome-survey/create',
    editUrl: '/welcome-survey/edit',
    renderChangeLanguegeFilter: true,
    lazy: true,
};

WelcomeSurveyListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(WelcomeSurveyListContainer));
